package model.network

import Flavor
import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.plugins.logging.SIMPLE
import io.ktor.http.URLProtocol
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

val json = Json { ignoreUnknownKeys = true }

class FlavorInjectedHttpClient(private val flavor: Flavor) {
    fun getClient() = HttpClient {
        install(ContentNegotiation) { json(json) }

        install(Logging) { logger = Logger.SIMPLE }

        install(HttpTimeout) {
            requestTimeoutMillis = 20000
            connectTimeoutMillis = 10000
        }

        defaultRequest {
            url {
                host = flavor.serverUrl
                protocol = URLProtocol.HTTPS.takeIf { flavor.serverHttps } ?: URLProtocol.HTTP
                flavor.serverPort?.let {
                    port = it
                }
            }
        }
    }
}